<app-carousel class="margin-bottom-custom-for-carousel"
              [sliderLength]="userCardsLength"
              [username]="user.username"
              [userCards]="userCards"
              [reservedIdentificationId]="reservedIdentificationId"
              [qrTeamWrappedCards]="qrTeamWrappedCards"
              [qrTeamForUi]="qrTeamForUi"
              [qrUserCreatedTeam]="qrUserCreatedTeam"
              [qrTeams]="qrTeams"
              [qrActiveTeamIndex]="qrActiveTeamIndex"
              [qrActiveSubscription]="qrActiveSubscription"
              [qrCurrentUserId]="user.id"
              [qrCurrentUserEmail]="user.email"
              (deleteCard)="deleteCardHandler($event)">
</app-carousel>
